module.exports = __webpack_public_path__ + "static/media/eth.ed79179a.svg";